import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthResetConfirmationComponent } from './auth-reset-confirmation/auth-reset-confirmation.component';
import { AuthResetFormComponent } from './auth-reset-form/auth-reset-form.component';

const routes: Routes = [
  {
    path: '',
    component: AuthResetFormComponent
  },
  {
    path:'auth-reset-confirmation',
    component: AuthResetConfirmationComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthResetFormRoutingModule { }
